<span class="material-symbols-outlined dialog__icon">cancel</span>
<h2 mat-dialog-title>DECLINE BOOKING</h2>
<mat-dialog-content>
    <p>Are you sure you want to decline this booking?</p>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row w-100 mx-0 g-3">
        <div class="col-12">
  <button mat-flat-button class="w-100" color="primary" mat-dialog-close cdkFocusInitial>KEEP BOOKING</button>

        </div>
        <div class="col-12">
  <button mat-button class="w-100" color="warn" [mat-dialog-close]="true" cdkFocusInitial>DECLINE BOOKING</button>

        </div>
    </div>
</mat-dialog-actions>